<template>
  <div>
    <div class="g-group">
      <div class="f-group">
        <div class="inner">
          <div class="text">基础图元</div>
          <div class="list">
            <div @click="baseDraw('point')" class="item">
              <div class="logo"><svg-icon class="icon" icon-class="p-point" /></div>
              <div class="title">点</div>
            </div>
            <div @click="baseDraw('billboard')" class="item">
              <div class="logo"><svg-icon class="icon" icon-class="p-billboard" /></div>
              <div class="title">图标</div>
            </div>
            <div @click="baseDraw('polyline3')" class="item">
              <div class="logo"><svg-icon class="icon" icon-class="p-line" /></div>
              <div class="title">线</div>
            </div>
            <div @click="baseDraw('bezier')" class="item">
              <div class="logo"><svg-icon class="icon" icon-class="p-curve" /></div>
              <div class="title">曲线</div>
            </div>
            <div @click="baseDraw('polygon2')" class="item">
              <div class="logo"><svg-icon class="icon" icon-class="p-ploygon" /></div>
              <div class="title">面</div>
            </div>
            <div @click="baseDraw('ellipse2')" class="item">
              <div class="logo"><svg-icon class="icon" icon-class="p-circle" /></div>
              <div class="title">圆</div>
            </div>
            <div @click="baseDraw('rectangle2')" class="item">
              <div class="logo"><svg-icon class="icon" icon-class="p-rectangle2" /></div>
              <div class="title">矩形</div>
            </div>
            <div @click="baseDraw('square2')" class="item">
              <div class="logo"><svg-icon class="icon" icon-class="p-rectangle" /></div>
              <div class="title">正方形</div>
            </div>
            <div @click="baseDraw('triangle2')" class="item">
              <div class="logo"><svg-icon class="icon" icon-class="p-triangle" /></div>
              <div class="title">三角形</div>
            </div>
          </div>
        </div>
      </div>
      <div class="f-group">
        <div class="inner">
          <div class="text">3D图元</div>
          <div class="list">
            <div @click="baseDraw('polygon3')" class="item">
              <div class="logo"><svg-icon class="icon" icon-class="p-hedral" /></div>
              <div class="title">面体</div>
            </div>
            <div @click="baseDraw('sector3')" class="item">
              <div class="logo"><svg-icon class="icon" icon-class="p-sector" /></div>
              <div class="title">扇形</div>
            </div>
            <div @click="baseDraw('square3')" class="item">
              <div class="logo"><svg-icon class="icon" icon-class="p-cube" /></div>
              <div class="title">立方体</div>
            </div>
            <div @click="baseDraw('triangle')" class="item">
              <div class="logo"><svg-icon class="icon" icon-class="p-triangular" /></div>
              <div class="title">三棱柱</div>
            </div>
            <div @click="baseDraw('ellipse3')" class="item">
              <div class="logo"><svg-icon class="icon" icon-class="p-cylinder" /></div>
              <div class="title">圆柱</div>
            </div>
            <div @click="baseDraw('ellipsoid3')" class="item">
              <div class="logo"><svg-icon class="icon" icon-class="p-sphere" /></div>
              <div class="title">球体</div>
            </div>
            <div @click="baseDraw('cone3')" class="item">
              <div class="logo"><svg-icon class="icon" icon-class="p-cone" /></div>
              <div class="title">圆锥</div>
            </div>
            <div @click="baseDraw('wall3')" class="item">
              <div class="logo"><svg-icon class="icon" icon-class="p-wall" /></div>
              <div class="title">墙体</div>
            </div>
            <div @click="baseDraw('polylineVolume3')" class="item">
              <div class="logo"><svg-icon class="icon" icon-class="p-pipeline" /></div>
              <div class="title">管道</div>
            </div>
          </div>
        </div>
      </div>
      <div class="f-group">
        <div class="inner">
          <div class="text">常用军标</div>
          <div class="list">
            <div @click="baseDraw('straightArrow3')" class="item">
              <div class="logo"><svg-icon class="icon" icon-class="p-line-arrow2" /></div>
              <div class="title">直线箭头</div>
            </div>
            <div @click="baseDraw('attackArrow3')" class="item">
              <div class="logo">
                <svg-icon class="icon" icon-class="p-attack-arrow2" />
              </div>
              <div class="title">攻击箭头</div>
            </div>
            <div @click="baseDraw('pincerArrow3')" class="item">
              <div class="logo"><svg-icon class="icon" icon-class="p-pincer" /></div>
              <div class="title">钳击箭头</div>
            </div>
            <div @click="baseDraw('squadCombat')" class="item">
              <div class="logo"><svg-icon class="icon" icon-class="p-combat" /></div>
              <div class="title">分队战斗</div>
            </div>
            <div @click="baseDraw('assaultDirection3')" class="item">
              <div class="logo"><svg-icon class="icon" icon-class="p-direction" /></div>
              <div class="title">突击方向</div>
            </div>
            <div @click="baseDraw('gatheringPlace')" class="item">
              <div class="logo"><svg-icon class="icon" icon-class="p-ground" /></div>
              <div class="title">集结地</div>
            </div>
          </div>
        </div>
      </div>
      <div class="f-group">
        <div class="inner">
          <div class="text">操作</div>
          <div class="list">
            <!-- <div @click="save()" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-save" /></div>
                            <div class="title">我的标绘</div>
                        </div> -->
            <div @click="clear()" class="item">
              <div class="logo"><svg-icon class="icon" icon-class="p-clear" /></div>
              <div class="title">清除</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="g-msg">提示:鼠标左键取点，右键结束绘制。(鼠标左键双击标绘即可删除选中标绘)</div> -->
  </div>
</template>

<script>
import PlotManage from "@/utils/cesiumBD/plot/PlotManage.js";
let plotUti = undefined;
/*******************UI*********************/
import com_point from "@/components/VectorPlot/compoent/point.vue";
import com_billboard from "@/components/VectorPlot/compoent/billboard.vue";
import com_line from "@/components/VectorPlot/compoent/line.vue";
import com_polygon from "@/components/VectorPlot/compoent/polygon.vue";
import com_circle from "@/components/VectorPlot/compoent/circle.vue";
import com_rectangle from "@/components/VectorPlot/compoent/rectangle.vue";
import com_ellipsoid from "@/components/VectorPlot/compoent/ellipsoid.vue";
import com_cylinder from "@/components/VectorPlot/compoent/cylinder.vue";
import com_wall from "@/components/VectorPlot/compoent/wall.vue";
import com_polylineVolume from "@/components/VectorPlot/compoent/polylineVolume.vue";
export default {
  data() {
    return {
      drawing: false,
    };
  },

  mounted() {
    plotUti = DBmap.plotUti;
    plotUti.bindPlotFlag(true);

    //plotUti.bindCallbackEdit(this.callbackEdit)
    //plotUti.onDbclick(this.dbclick);
  },

  beforeDestroy() {
    //plotUti.bindPlotFlag(false);
    //plotUti.removeDbclick();
  },

  methods: {
    drawDone() {
      this.$bus.$emit("drawDone");
    },
    baseDraw(type) {
      this.$parent.close();
      plotUti.start(type);
      this.type = type;
      if ("point" != type && "billboard" != type) {
        this.$bus.$emit("drawDone", type); //true需要推演
      }
    },

    clear() {
      plotUti && plotUti.clear();
    },
    save() {},
  },
};
</script>

<style lang="scss" scoped>
.g-group {
  display: flex;
  flex-direction: column;
}

.g-msg {
  color: #e6a23c;
  font-size: 12px;
  padding: 2px 0 0 10px;
}

.f-group {
  color: #ffffff;
  font-size: 12px;
  flex: auto;

  .inner {
    padding: 0 10px;

    .list {
      display: grid;
      grid-gap: 10px;
      justify-items: center;
      align-items: center;
      grid-template-columns: repeat(4, 1fr);

      .item {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        cursor: pointer;
        width: 100%;
        border: 1px #c3c3c3 dashed;
        padding: 6px 0;

        .icon {
          width: 20px;
          height: 20px;
        }
      }
    }

    .text {
      text-align: left;
      padding: 10px 0;
      color: #e6a23c;
    }
  }
}
</style>
